// extracted by mini-css-extract-plugin
module.exports = {"location-container":"LocationLabel_location-container__I0wDH","icon-container":"LocationLabel_icon-container__I99K2","location":"LocationLabel_location__2cJmy"};